import React, { useEffect, useState } from "react"
import { useMemo } from "react"

import { Card, CardTitle } from "../../components/Card"
import { PiePlotChart } from "../../components/Chart"

import "./styles.scss"

const ProducersJourneyScreen = ({
  journey,
  users,
}) => {
  const [tagsPercent, setTagsPercent] = useState([])

  const unionJourney = journey.filter((item) => users.find((data) => data.id === item.Produtor))
  const completedJourney = unionJourney.filter(
    (item) => item.CountVisualizado >= item.NumeroDeItens,
  )
  const incompleted = [
    ...new Set(
      unionJourney
        .filter((item) => !completedJourney.find((a) => a.Produtor === item.Produtor))
        .map((item) => item.Produtor),
    ),
  ]
  const withoutJourney = [
    ...new Set(
      users
        .filter((item) => !journey.find((data) => item.id === data.Produtor))
        .map((item) => item.id),
    ),
  ]

  const semTags = [
    ...new Set(users.filter((user) => user.tags?.filter((item) => item?.tag).length === 0)),
  ]

  const getTagsPercent = () => {
    let tagsCount = []
    let tags = []
    users.map((user) =>
      user.tags
        ?.filter((item) => item?.tag !== null)
        .map((tags) => tags.tag)
        .filter((tag) => tag.projectId === "" && tags.push(tag?.name)),
    )

    for (let i = 0; i < tags.length; i++) {
      let count = 0
      for (let j = 0; j < tags.length; j++) {
        if (tags[i] === tags[j]) {
          ++count
        }
      }

      tagsCount.push({
        label: tags[i],
        value: count,
      })
    }

    return [...new Set(tagsCount.map(JSON.stringify))].map(JSON.parse)
  }

  useEffect(() => {
    if (users) {
      setTagsPercent(getTagsPercent())
    }
  }, [users])

  return (
    <div className="journey-screen">
      <div className="indicador-container">
        <div className="indicador-vcard">
          <Card className="no-border">
            <span className="indicador-vcard-title">{users.length}</span>
            <span className="indicador-vcard-subtitle">Produtores</span>
          </Card>
          <Card className="no-border">
            <span className="indicador-vcard-title">
              {[...new Set(unionJourney.map((item) => item.Produtor))].length}
            </span>
            <span className="indicador-vcard-subtitle">Em Jornada</span>
          </Card>
        </div>
        <Card className="no-border">
          <CardTitle className="flex-start" title="Jornada do Produtor" />
          <div className="graph">
            <PiePlotChart
              data={[
                { value: withoutJourney.length, label: "Sem jornada" },
                { value: incompleted.length, label: "Jornada em andamento" },
              ].concat(
                [...new Set(completedJourney && completedJourney.map((item) => item.Trilha))].map(
                  (label) => ({
                    value: [
                      ...new Set(
                        completedJourney
                          .filter((item) => item.Trilha === label)
                          .map((item) => item.Produtor),
                      ),
                    ].length,
                    label,
                  }),
                ),
              )}
            />
          </div>
        </Card>
        <Card className="no-border">
          <CardTitle className="flex-start" title="Classificação do Produtor" />
          <div className="graph">
            <PiePlotChart
              data={[{ value: semTags.length, label: "Sem tag" }].concat(tagsPercent)}
            />
          </div>
        </Card>
      </div>
    </div>
  )
}

export default ProducersJourneyScreen
